import { Box } from '@hivebrite/design-system/Box';
import { useIsMobileDevice } from '@hivebrite/react-hooks';

import { type Event } from 'hb-react/shared/apps/Events/types';
import Attendees from 'hb-react/shared/components/DesignSystem/Attendees';

export const AttendeesRow = ({
  event,
  mt = 4,
  imgSize = 40,
}: {
  event: Pick<Event, 'has_attendees' | 'id' | 'type'>;
  imgSize?: number;
  mt?: number;
}) => {
  const isMobile = useIsMobileDevice();

  return (
    <Box mt={mt}>
      <Attendees
        lazy={event.has_attendees}
        imgSize={imgSize}
        eventId={event.id}
        eventType={event.type}
        maxAvatars={isMobile ? 4 : 5}
      />
    </Box>
  );
};
